import { Dayjs } from "dayjs"
import { Draw } from "./draw"
import { IDrawDetail } from "./drawDetail.types"
import { IDrawReward } from "./drawReward.types"

export class DrawDetail extends Draw implements IDrawDetail {
  constructor(
    id: string,
    name: string,
    displayName: string,
    startDateTime: Dayjs,
    entryDeadlineDateTime: Dayjs,
    completionDateTime: Dayjs,
    public winnerPublicationDateTime: Dayjs,
    public participantCount: number,
    public rewards: IDrawReward[],
    public winnerNotificationDateTime: Dayjs,
  ) {
    super(
      id,
      name,
      displayName,
      startDateTime,
      entryDeadlineDateTime,
      completionDateTime,
    )
  }
}
